import { render, staticRenderFns } from "./corporateBranchTable.vue?vue&type=template&id=d8670abc&"
import script from "./corporateBranchTable.vue?vue&type=script&lang=js&"
export * from "./corporateBranchTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports